export function initBackendAndElectronSocket(
  /*backendSocket,*/ electronSocket,
) {
  electronSocket.on("connect", function() {
    console.log("connected to electron app. So send message to backend");
    // backendSocket.emit("hardware-connected");
  });

  electronSocket.on("disconnect", function() {
    console.log("disconnected electron app", electronSocket.connected);
  });

  //   backendSocket.on("connect", function() {
  //     if (electronSocket && electronSocket.connected) {
  //       backendSocket.emit("hardware-connected");
  //     }
  //   });

  //   backendSocket.on("ping-hardware", async function() {
  //     let hardware_id = await getHardwareId();
  //     let sys_info = await getResourceUsageInfo();
  //     const key = Object.keys(sys_info.macAddress)[0];
  //     let macAddress = sys_info.macAddress[key].mac;
  //     backendSocket.emit("hardware-ping-back", {
  //       hardware_id,
  //       sys_info,
  //       macAddress
  //     });
  //   });

  //   backendSocket.on("get-hardware-id", async function() {
  //     let hardware_id = await getHardwareId();
  //     let sys_info = await getResourceUsageInfo();
  //     const key = Object.keys(sys_info.macAddress)[0];
  //     let macAddress = sys_info.macAddress[key].mac;
  //     window.localStorage.setItem("hardware_mac_address", macAddress);
  //     // hardware_id = hardware_id + "-" + macAddress;
  //     let device = "POS";
  //     backendSocket.emit("hardware-id", hardware_id, device, macAddress);
  //   });

  //   backendSocket.on("get-system-info", async function() {
  //     let sys_info = await getResourceUsageInfo();
  //     backendSocket.emit("system-info", sys_info);
  //   });

  //   backendSocket.on("device-unique-code", async function(code) {
  //     console.log("device-unique-code", code);
  //     const {unique_code, hardware_name, hardware_mac_address} = code;
  //     window.localStorage.setItem("deiviceUniqueCode", unique_code);
  //     window.localStorage.setItem("hardware_name", hardware_name);
  //     window.localStorage.setItem("hardware_mac_address", hardware_mac_address);
  //     window.localStorage.setItem("HWUID", unique_code);
  //   });
}



// WEBPACK FOOTER //
// ./src/socket.io/init.js